import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { CommonEffects } from './common.effects';
import * as CommonReducer from './common.reducer';
import { commonFeatureKey } from './common.state';

@NgModule({
    declarations: [],
    imports: [CommonModule, StoreModule.forFeature(commonFeatureKey, CommonReducer.reducer), EffectsModule.forFeature([CommonEffects])],
})
export class CommonStoreModule {}
